import { HideInfobarDetailsButton } from 'owa-locstrings/lib/strings/hideinfobardetailsbutton.locstring.json';
import { ShowInfobarDetailsButton } from 'owa-locstrings/lib/strings/showinfobardetailsbutton.locstring.json';
import loc from 'owa-localize';
/* tslint:disable:jsx-no-lambda WI:47750 */
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import MultiRecipientMailtip from './MultiRecipientMailtip';
import { InfoBarMessagePart } from 'owa-info-bar-view';
import * as React from 'react';

import MultiRecipientDetails from './MultiRecipientDetails';
import ColorScheme from 'owa-color-utils/lib/ColorScheme';
import { createRemoveAllRecipientsLink } from '../utils/createRemoveRecipientLinks';
import { MailTipsCategory } from '../datapoints';

export interface RemoveMultiRecipientMailtipProps {
    colorScheme?: ColorScheme;
    messageInfoText: string;
    onRemove: (recipients: EmailAddressWrapper[]) => void;
    recipientEmails: EmailAddressWrapper[];
    mailTipsCategory?: MailTipsCategory;
}

const RemoveMultiRecipientMailtip = (props: RemoveMultiRecipientMailtipProps) => {
    return (
        <MultiRecipientMailtip
            colorScheme={props.colorScheme}
            messageInfoElement={
                <InfoBarMessagePart
                    colorScheme={props.colorScheme}
                    messagePart={props.messageInfoText}
                />
            }
            removeAllActionElement={
                <InfoBarMessagePart
                    colorScheme={props.colorScheme}
                    messagePart={createRemoveAllRecipientsLink(
                        props.recipientEmails,
                        props.onRemove,
                        props.mailTipsCategory
                    )}
                />
            }
            showHideDetails={{
                showDetailsText: loc(ShowInfobarDetailsButton),
                hideDetailsText: loc(HideInfobarDetailsButton),
                detailsElement: null,
            }}
            detailsRenderer={() => (
                <MultiRecipientDetails
                    colorScheme={props.colorScheme}
                    recipientEmails={props.recipientEmails}
                    onRemove={props.onRemove}
                    mailTipsCategory={props.mailTipsCategory}
                />
            )}
            mailTipsCategory={props.mailTipsCategory}
            recipientCount={props.recipientEmails.length}
        />
    );
};

export default RemoveMultiRecipientMailtip;
